import { render, staticRenderFns } from "./edit-teacher.vue?vue&type=template&id=605c3b9a&"
import script from "./edit-teacher.vue?vue&type=script&lang=js&"
export * from "./edit-teacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports